import 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Rx';
import { Http } from '@angular/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { ApiService } from '../../../shared/services/api.service';
import { CognitoUtil } from 'app/main/shared/services/cognito.service';

@Injectable()
export class TodoService {

  static baseURL = environment.todoLink;
  static attachmentsURL = environment.preSign;

  apiService: ApiService = new ApiService(this.http, this.cognito);

  constructor(
    private http: Http, private cognito: CognitoUtil
  ) { }

  // GET

  getAllProjects(userId: string) {
    return this.apiService.getCall('todoLink', `user/${userId}/todo/lists/`);
  }

  updateProject(userId: string, listId: string, projectData) {
    return this.apiService.putCall('todoLink', `user/${userId}/todo/lists/${listId}`, projectData);
  }


  createProject(userId: string, projectData) {
    return this.apiService.postCall('todoLink', `user/${userId}/todo/lists`, projectData);

  }

  // // POST

  addProject(userId: string, projectData) {
    return this.apiService.postCall('todoLink', `user/${userId}/todo/lists/`, projectData);
  }

  deleteProject(userId, listId) {
    return this.apiService.deleteCall('todoLink', `user/${userId}/todo/lists/` + listId);
  }

  addTask(userId: string, listId: string, projectData) {
    return this.apiService.postCall('todoLink', `user/${userId}/todo/lists/${listId}/tasks`, projectData);
  }

  getTask(userId: string, listId: string) {
    return this.apiService.getCall('todoLink', `user/${userId}/todo/lists/${listId}/tasks`);
  }

  updateTask(userId: string, listId: string, taskId: string, projectData) {
    return this.apiService.putCall('todoLink', `user/${userId}/todo/lists/${listId}/tasks/${taskId}`, projectData);
  }

  deleteTask(userId: string, listId: string, taskId: string) {
    return this.apiService.deleteCall('todoLink', `user/${userId}/todo/lists/${listId}/tasks/` + taskId);
  }

  getTaskById(userId: string, projectData, listId, taskId) {
    return this.apiService.getCall('todoLink', `user/${userId}/todo/lists/${listId}/tasks` + taskId);
  }

  getTasksByDay(userId, day) {
    return this.apiService.getCall('todoLink', `user/${userId}/todo/tasks?list_by=${day.toUpperCase()}`);
  }
  copyTask(userId, listId, taskId, another_list_id) {
    return this.apiService.putCall('todoLink', `user/${userId}/todo/lists/${listId}/tasks/${taskId}/copy/${another_list_id}`);
  }
  moveTask(userId, listId, taskId, another_list_id) {
    return this.apiService.putCall('todoLink', `user/${userId}/todo/lists/${listId}/tasks/${taskId}/move/${another_list_id}`);
  }
  createNewList(userId, model) {
    return this.apiService.postCall('todoLink', `user/${userId}/todo/lists/unnamed`, model);
  }
  addTasksSteps(userId, listId, taskId, steps) {
    return this.apiService.postCall('todoLink', `user/${userId}/todo/lists/${listId}/tasks/${taskId}/steps`, steps);
  }
  updateSteps(userId, listId, taskId, step_id, steps) {
    return this.apiService.putCall('todoLink', `user/${userId}/todo/lists/${listId}/tasks/${taskId}/steps/${step_id}`, steps);
  }
  deleteSteps(userId, listId, taskId, step_id) {
    return this.apiService.deleteCall('todoLink', `user/${userId}/todo/lists/${listId}/tasks/${taskId}/steps/${step_id}`);
  }
  updatePreferences(userId, preferences) {
    return this.apiService.putCall('todoLink', `user/${userId}/todo/preferences`, preferences);
  }
  getPreferences(userId) {
    return this.apiService.getCall('todoLink', `user/${userId}/todo/preferences`);
  }
  getShared(userId) {
    return this.apiService.getCall('todoLink', `user/${userId}/todo/shared`);
  }
  updateShare(userId, list_id, share) {
    return this.apiService.putCall('todoLink', `user/${userId}/todo/lists/${list_id}/share`, share);
  }
  removeShare(userId, list_id, unshare) {
    return this.apiService.putCall('todoLink', `user/${userId}/todo/lists/${list_id}/unshare`, unshare);
  }
  assign(userId, list_id, task_id, assign) {
    return this.apiService.putCall('todoLink', `user/${userId}/todo/lists/${list_id}/tasks/${task_id}/assign`, assign);
  }
  removeAssign(userId, list_id, task_id, unassign) {
    return this.apiService.putCall('todoLink', `user/${userId}/todo/lists/${list_id}/tasks/${task_id}/unassign`, unassign);
  }
  getAttachments(user_id, list_id, todo_id) {
    return this.apiService.getCall('preSign', `users/${user_id}/todos/lists/${list_id}/todo/${todo_id}/attachments/list`);
  }
  addAttachments(user_id, list_id, todo_id, file) {
    return this.apiService.getCall('preSign', `users/${user_id}/todos/lists/${list_id}/todo/${todo_id}/attachments/${file}`);
  }

  uploadFile(link, file) {
    let url: string[] = link.split('https://dev-eguard-documents.s3.amazonaws.com/')
    return this.apiService.patchCall(link, file);
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/common/todo-tab/todo.service.ts